// extracted by mini-css-extract-plugin
export var searchHeader = "_6h-0";
export var searchHeaderDark = "_6h-1";